"use strict";

function initRecaptcha(element) {
  window.grecaptcha.render(element, {
    'sitekey': element.getAttribute('data-sitekey')
  });
}

function fillServicesField() {
  var checkedAreas = document.querySelectorAll(".service:checked ~ label");
  var servicesField = document.querySelector(".services-field");

  switch (checkedAreas.length) {
    case 0:
      servicesField.innerHTML = "";
      break;

    case 1:
      servicesField.innerHTML = checkedAreas[0].innerHTML;
      break;

    default:
      servicesField.innerHTML = checkedAreas.length + " Leistungen";
  }

  setServicesBadges();
}

function setServicesBadges() {
  var categories = document.querySelectorAll("form .service-category");
  categories.forEach(function (category) {
    var count = category.querySelectorAll(".service:checked").length;

    if (count > 0) {
      category.querySelector("h4").setAttribute("data-value", count);
    } else {
      category.querySelector("h4").removeAttribute("data-value");
    }
  });
}

function setAdvancedSearchBadge() {
  var valuesSet = 0;
  var categories = document.querySelectorAll("form .service-category");
  categories.forEach(function (category) {
    valuesSet += category.querySelectorAll(".service:checked").length;
  });

  if (valuesSet > 0) {
    document.querySelector(".advanced-search").setAttribute("data-value", valuesSet);
  } else {
    document.querySelector(".advanced-search").removeAttribute("data-value");
  }
}

function validateLocationField(input) {
  input.checkValidity();

  if (input.validity.valueMissing || input.validity.tooShort) {
    input.setCustomValidity("Bitte geben Sie mindestens die ersten drei Ziffern einer Postleitzahl ein.");
  } else if (input.validity.patternMismatch) {
    input.setCustomValidity("Bitte geben Sie nur Ziffern ein.");
  } else if (input.validity.tooLong) {
    input.setCustomValidity("Bitte geben Sie höchstens fünf Ziffern ein.");
  } else {
    input.setCustomValidity("");
  }
}

function initIndexPage() {
  // Hier ist requestAnimationFrame() nötig, weil Gecko sonst ggf. die Validierung ausführt, bevor der neue Wert für die Validierungslogik
  // sichtbar ist. Das ist insbesondere dann der Fall, wenn der Wert aus einem Autocomplete-Menü ausgewählt wurde.
  document.on("input", ".location-field", function (event) {
    return requestAnimationFrame(function () {
      return validateLocationField(event.target);
    });
  });
  validateLocationField(document.querySelector(".location-field"));
  document.on("click", ".advanced-search", function (event) {
    event.stopImmediatePropagation();
    document.querySelector(".advanced-search-container").toggleClass("collapsed");
  });
  document.on("change", ".advanced-search-container input", setAdvancedSearchBadge);
  setAdvancedSearchBadge();
}

function initResultsPage() {
  document.on("input", ".location-field", function (event) {
    return requestAnimationFrame(function () {
      return validateLocationField(event.target);
    });
  });
  validateLocationField(document.querySelector(".location-field"));
  document.on("click", "main", function (event) {
    if (event.target.matchingParent(".result-detail") === null && event.target.matchingParent(".result") === null) {
      var detail = document.querySelector(".result-detail");
      detail && detail.collapse();
    }
  });
  document.on("click", ".open-refine-search-link", function (event) {
    event.preventDefault();
    document.querySelector(".sidebar-mode-search").classList.add("active");
    document.querySelector(".sidebar-mode-results").classList.remove("active");
  });

  function replaceMainWithUrl(url) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var xhr = new XMLHttpRequest();

    xhr.onload = function (event) {
      if (event.target.status < 200 || event.target.status >= 300) {
        return;
      }

      var parser = new DOMParser();
      var html = parser.parseFromString(event.target.responseText, "text/html");
      var oldMain = document.querySelector("main");
      var newMain = html.querySelector("main");
      newMain.remove();
      newMain.querySelectorAll("input[type=date]").forEach(initDatePicker);
      oldMain.replaceWith(newMain);
      newMain.querySelectorAll(".g-recaptcha").forEach(initRecaptcha);
    };

    xhr.open(payload ? "POST" : "GET", url);
    xhr.send(payload);
  }

  function isMainVisible() {
    return window.getComputedStyle(document.querySelector("main"), null).display !== "none";
  }

  document.on("click", ".result", function (event) {
    if (!isMainVisible()) {
      return;
    }

    event.preventDefault();
    [].forEach.call(document.querySelectorAll(".result.active"), function (el) {
      el.classList.remove("active");
    });
    this.classList.add("active");
    replaceMainWithUrl(this.getAttribute("href"));
  });
  document.on("click", "main a", function (event) {
    var href = this.getAttribute("href"); // Nur Links, die kein Schema nach RFC 3986 spezifizieren. So erkennen wir interne Links.

    if (!this.classList.contains("no-main") && !href.match(/^[a-z][a-z0-9.+-]*:/i) && isMainVisible()) {
      event.preventDefault();
      replaceMainWithUrl(href);
    }
  });
  document.on("click", ".imprint-container a", function (event) {
    if (isMainVisible()) {
      event.preventDefault();
      replaceMainWithUrl(this.getAttribute("href"));
    }
  });
  document.on("submit", "main form", function (event) {
    if (isMainVisible()) {
      event.preventDefault();
      replaceMainWithUrl(this.getAttribute("action"), new FormData(this));
    }
  });
}

function initServicesBadges() {
  document.on("change", ".service", setServicesBadges);
  setServicesBadges();
}

function initShared() {
  document.querySelectorAll("input[type=date]").forEach(initDatePicker);
  document.on("click", ".clear-delivery-date", function (event) {
    event.preventDefault();

    event.target.parentNode.querySelector(".delivery-date-field")._flatpickr.clear();
  });
  document.on("blur", ".delivery-date-field.input", function (event) {
    event.target.parentNode.querySelector("input[type=hidden]")._flatpickr.setDate(event.target.value);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector("html.index") !== null) {
    initIndexPage();
  }

  if (document.querySelector("html.results") !== null) {
    initResultsPage();
  }

  if (document.querySelector("form .service-category") !== null) {
    initServicesBadges();
  }

  initShared();
});